import { Headers, BaseRequestOptions } from '@angular/http';
import { Injectable } from '@angular/core';

// Todo: Merge default headers when header passed with http request

@Injectable()
export class CustomRequestOptions extends BaseRequestOptions {
    headers: Headers = new Headers({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    });
    constructor() {
        super();
        // Todo: add the code if specific header needs to be added for all the modules.
    }
}



// WEBPACK FOOTER //
// ./src/common/http/custom-request-options.ts